// extracted by mini-css-extract-plugin
export default {"commentWithLabel":"comment-module__commentWithLabel--ue9BC","comment":"comment-module__comment--SRmHh","errorMessage":"comment-module__errorMessage--NObJd"};